import React from 'react';
import { Box } from '@mantine/core';
import { Z_INDEX } from '../../components/layout/LayoutConstants';

interface MobileCartWrapperProps {
  children: React.ReactNode;
  isMobile: boolean;
}

export const MobileCartWrapper: React.FC<MobileCartWrapperProps> = ({ children, isMobile }) => {
  if (isMobile) {
    return (
      <Box
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          width: '100%',
          zIndex: Z_INDEX.SIDEBAR,
          backgroundColor: 'rgba(15, 15, 15, 0.8)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          borderTop: '1px solid rgba(255, 255, 255, 0.08)',
          padding: 16
        }}
      >
        {children}
      </Box>
    );
  }

  return <>{children}</>;
};
